module.exports = __webpack_public_path__ + "19af9dc851325e00fb861dfea1c3c8c7.jpg";